import { render, staticRenderFns } from "./searchWrapper.vue?vue&type=template&id=65133bdb&scoped=true"
import script from "./searchWrapper.vue?vue&type=script&lang=js"
export * from "./searchWrapper.vue?vue&type=script&lang=js"
import style0 from "./searchWrapper.vue?vue&type=style&index=0&id=65133bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65133bdb",
  null
  
)

export default component.exports